import gql from 'graphql-tag';

export const POLL_INTERVAL = 1000;

export const GET_NOTES = gql`
query localizedUnitNotes($hav: String!, $tripBoardUuid: String!, $unitTriad: String!, $locale: String!, $timezone: String!) {
    localizedUnitNotes(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad, locale: $locale, timezone: $timezone) {
        pagination {
            totalItems
        },
        unitNotes {
            localeCreateTime,
            localeCreateDate,
            wasCreatedToday,
            createTime,
            isMine,
            text,
            updateTime,
            author {
                firstName,
                lastName,
                publicImageUrl
            }
            uuid
        }
    }
}`;

export const ADD_NOTE = gql`
mutation addLocalizedNoteToTripBoardUnit($hav: String!, $tripBoardUnitNoteInput: TripBoardUnitNoteInput!, $locale: String!, $timezone: String!) {
    addLocalizedNoteToTripBoardUnit(hav: $hav, tripBoardUnitNoteInput: $tripBoardUnitNoteInput, locale: $locale, timezone: $timezone) {
        uuid,
        createTime,
        updateTime,
        localeCreateTime,
        localeCreateDate,
        unitTriad,
        isMine,
        text,
        author {
            firstName,
            lastName,
            publicImageUrl
        }
    }
}`;

// locale + timezone required for localized notes
export const mapStateToProps = ({
    system: {
        locale
    },
    tripboard: {
        comments: {
            timezone = '0'
        } = {}
    } = {}
}) => ({
    locale,
    timezone
});

export const getOptions = ({
    boardId,
    hav,
    listingId,
    locale,
    timezone
}) => ({
    variables: {
        tripBoardUuid: boardId,
        hav,
        unitTriad: listingId,
        locale,
        timezone
    },
    notifyOnNetworkStatusChange: false,
    errorPolicy: 'all'
});

export const pollingOptions = ({
    boardId,
    hav,
    listingId,
    locale,
    timezone
}) => ({
    variables: {
        tripBoardUuid: boardId,
        hav,
        unitTriad: listingId,
        locale,
        timezone
    },
    notifyOnNetworkStatusChange: false,
    pollInterval: POLL_INTERVAL,
    errorPolicy: 'all'
});

export const mutationProps = ({mutate, ownProps}) => ({
    addNote: ({onError, onLoading, onSuccess, text}) => {
        const {hav, boardId, listingId, locale, timezone} = ownProps;
        onLoading(); // component state hook

        return mutate({
            variables: {
                hav,
                tripBoardUnitNoteInput: {
                    text,
                    tripBoardUuid: boardId,
                    unitTriad: listingId
                },
                locale,
                timezone
            },
            update(proxy, data = {}) {
                const {addLocalizedNoteToTripBoardUnit} = data.data;
                const variables = {
                    hav,
                    tripBoardUuid: boardId,
                    unitTriad: listingId,
                    locale,
                    timezone
                };

                const cache = proxy.readQuery({query: GET_NOTES, variables}) || {};
                const {localizedUnitNotes} = cache;

                // were we successful?
                if (addLocalizedNoteToTripBoardUnit && localizedUnitNotes && Array.isArray(localizedUnitNotes.unitNotes)) {
                    cache.localizedUnitNotes.pagination.total++;
                    cache.localizedUnitNotes.unitNotes.unshift(addLocalizedNoteToTripBoardUnit);
                    proxy.writeQuery({query: GET_NOTES, variables, data: cache});
                    onSuccess(); // component state hook
                } else {
                    onError(); // component state hook
                }
            }
        })
        .catch(() => {
            onError(); // component state hook
        });
    }
});


// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/components/comments-graphql.js